<template>
  <div class="s_member_send_pop">
    <el-dialog class="s-pop" title="" :visible.sync="show">
      <div class="s-pop-container">
        <div class="s-pop-big-title">
          到期提醒
        </div>
        <div class="s-pop-title" >
          {{ memberInfo.notice }}
        </div>
        <div class="s-pop-btn-box">
          <div @click="onClose" class="s-pop-btn g-flex-align-center g-flex-justify-center">
            <span>我已知晓</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      form: {
        moteId: 0,
        myId: 0
      },
      memberInfo: {}
    }
  },
  methods: {
    onShow(memberInfo) {
      this.memberInfo = memberInfo
      this.show = true
    },
    onClose() {
      this.show = false
    },
    kefuClick() {
      // window.open(this.$global.kefu.KefuUrl + `&metadata={"name":"用户id:${this.form.myId}","comment":"模特id:${this.form.moteId}"}`)
      this.onClose()
    }
  },
}
</script>

<style lang='scss'>
.s_member_send_pop {
  .s-pop {
    .el-dialog {
      margin-top: 30vh !important;
      width: 400px !important;
      .el-dialog__header {
        padding: 10px;
      }
      .el-dialog__body {
        padding: 0px 10px 20px 10px;
      }
    }
    .s-pop-container {
      .s-pop-big-title {
        font-size: 18px;
        text-align: center;
        font-weight: 700;
        padding: 15px 0;
      }
      .s-pop-title {
        font-size: 16px;
        text-align: center;
        font-weight: 700;
        line-height: 22px;
        color: red;
      }
      .s-pop-btn-box {
        padding: 20px 10px;
        .s-pop-btn {
          padding: 5px;
          background: $mainBlue;
          color: $white;
          border-radius: 5px;
          height: 40px;
          cursor: pointer;
          word-break: normal;
        }
      }
    }
  }
}
</style>